import { Button, message, Upload as UploadAntd, Image } from "antd";
import React, { useState, useEffect } from "react";
import { UploadOutlined } from "@ant-design/icons";
import { uploadViaBackend } from "../helper/uploadViaBackend";
import { ShowToast, Severty } from "../helper/toast";
import { getFileExtension } from "../helper/functions";
import lang from "../helper/langHelper";

const SingleImageUpload = ({
  fileType,
  value,
  imageType,
  btnName,
  onChange,
  size = 50,
  width = 600,
  height = 600,
  isDimension = false,
  ...props
}) => {
  const [file, setFile] = useState([]);

  const checkImageDimensions = (file) => {
    return new Promise((resolve, reject) => {
      const img = document.createElement("img");

      img.onload = () => {
        if (img.width === width && img.height === height) {
          resolve();
        } else {
          reject(
            `Please upload an image with dimensions (${width}X${height}). uploaded image is ${img.width} X ${img.height}`
          );
        }
      };

      img.src = URL.createObjectURL(file);
    });
  };

  const beforeUpload = async (file) => {
    try {
      if (fileType.includes(file.type)) {
      } else {
        ShowToast("File format is not correct", Severty.ERROR);
        return false;
      }
      const isLt2M = file.size / 1024 / 1024 < size;

      if (!isLt2M) {
        ShowToast(`Image must be smaller than ${size} MB!`, Severty.ERROR);
        return false;
      }
      // If check dimension
      // isDimension && (await checkImageDimensions(file));
      return true;
    } catch (err) {
      ShowToast(err, Severty.ERROR);
      return false;
    }
  };

  const onRemove = () => {
    setFile([]);
    if (onChange) {
      onChange("");
    }
  };

  useEffect(() => {
    console.log(value, "value");
    if (value) {
      setFile([value]);
    } else {
      setFile([]);
    }
  }, [value]);

const uploadFileToS3 = async (file) => {
  // Uploads go through the backend (no S3 keys in the browser).
  return await uploadViaBackend(file, `tech_market/${imageType}`);
};

  const handleImgChange = async (event) => {
    const { file } = event;
    setFile([file]);
    try {
      const data = await uploadFileToS3(file, "invent-co-new");
      const fileData = {
        uid: file.uid,
        name: file.name,
        status: "done",
        url: data.Location,
        thumbUrl: data.Location,
      };
      setFile([fileData]);
      if (onChange) {
        onChange([fileData]);
      }
      //   setFile([fileData]);
      console.log(data);
    } catch (err) {
      console.error(err);
      ShowToast(
        (err && (err.message || err.Message)) || "Upload failed. Please try again.",
        Severty.ERROR
      );
      setFile([]);
      if (onChange) onChange([]);
    }
  };
  console.log(file, "file1111");
  return (
    <UploadAntd
      listType="picture"
      maxCount={1}
      beforeUpload={beforeUpload}
      customRequest={handleImgChange}
      onRemove={onRemove}
      fileList={file}
      accept={fileType.join(",")}
      {...props}
    >
      {file && file.length > 0 && file !== "" ? null : (
        <Button icon={<UploadOutlined />}>
          {" "}
          {btnName ? `${lang("Upload")} ${btnName}` : ""}
        </Button>
      )}
    </UploadAntd>
  );
};

export default SingleImageUpload;
